<template>
  <b-modal
    :id="id"
    ref="modal"
    hide-header
    hide-footer
    centered
    size="lg"
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    @shown="onShown"
  >
    <!-- Header -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-search text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Localizar Venda (Pré-Fatura)</h5>
        <small class="text-white opacity-75">Selecione a venda original para iniciar a devolução</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="hide">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div> 

    <div class="p-4 bg-white">
      <!-- Search Filters -->
      <div class="search-bar-premium mb-4">
        <b-row align-v="end">
          <b-col md="5">
            <label class="small font-weight-bold text-muted">Venda / Pedido</label>
            <b-form-input
              ref="inputSearch"
              v-model="filtro.pedido"
              placeholder="Nº Venda ou Controle..."
              class="custom-input-premium"
              @keydown.enter.native="pesquisar"
            />
          </b-col>
          <b-col md="5">
            <label class="small font-weight-bold text-muted">Período</label>
            <div class="d-flex align-items-center">
              <cec-input-data v-model="filtro.dt1" style="width: 140px" />
              <span class="mx-2 text-muted">-</span>
              <cec-input-data v-model="filtro.dt2" style="width: 140px" />
            </div>
          </b-col>
          <b-col md="2">
            <b-button variant="primary" block class="font-weight-bold" @click="pesquisar" :disabled="isBusy">
              <i class="fa fa-search"></i>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <!-- Results Table -->
      <div class="table-container shadow-xs rounded border overflow-hidden">
        <b-table
          hover
          small
          responsive
          show-empty
          empty-text="Nenhuma venda encontrada"
          :items="vendas"
          :fields="fields"
          :busy="isBusy"
          class="modern-premium-table mb-0"
          @row-clicked="selecionar"
        >
          <template #cell(VL_TOTAL_NFE)="data">
            {{ formatarMoeda(data.value) }}
          </template>
          <template #cell(DT_SAIDA)="data">
            {{ formatarData(data.value) }}
          </template>
        </b-table>
      </div>
    </div>

    <div class="p-3 bg-light border-top d-flex justify-content-end">
      <b-button variant="secondary" pill class="px-4" @click="hide">Cancelar</b-button>
    </div>
  </b-modal>
</template>

<script>
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools.js'

export default {
  name: 'PesquisaVendasDevolucaoModal',
  components: { CecInputData },
  props: {
    id: { type: String, default: 'modal-pesquisa-vendas-devolucao' },
    clienteId: { type: Number, default: null }
  },
  data() {
    return {
      isBusy: false,
      vendas: [],
      filtro: {
        pedido: '',
        dt1: Tools.getAcrescentarData(Tools.getDataAtual(), -30),
        dt2: Tools.getDataAtual()
      },
      fields: [
        { key: 'SEQUENCIA', label: 'ID', sortable: true },
        { key: 'DOCUMENTO', label: 'Nº Venda', sortable: true },
        { key: 'DT_SAIDA', label: 'Data', sortable: true },
        { key: 'CLIENTE_NOME', label: 'Cliente', sortable: true },
        { key: 'VL_TOTAL_NFE', label: 'Valor', sortable: true, tdClass: 'text-right' }
      ]
    }
  },
  methods: {
    formatarMoeda: Tools.formatCurrency,
    formatarData: Tools.formatarDataBR,
    onShown() {
      this.$refs.inputSearch.focus()
      this.pesquisar()
    },
    pesquisar() {
      this.isBusy = true
      const payload = {
        ...this.filtro,
        clienteId: this.clienteId
      }
      this.$store.dispatch('devolucao/pesquisarVendas', payload)
        .then(res => {
          this.vendas = res
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    selecionar(item) {
      this.$emit('selecionado', item)
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    }
  }
}
</script>

<style scoped>
.header-icon-wrapper {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
}

.custom-input-premium {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  height: 38px;
}

.table-container {
  max-height: 400px;
  overflow-y: auto;
}

.modern-premium-table >>> th {
  background: #f8fafc;
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  padding: 10px;
  border-top: none;
}

.modern-premium-table >>> td {
  padding: 10px;
  font-size: 13px;
  cursor: pointer;
}

.bg-white-10 {
  background: rgba(255, 255, 255, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/devolucao/PesquisaVendasDevolucaoModal.vue